/**
 * @file reports.js
 * @description Rutas de la sección "Reportes" del Dashboard. Visible solo
 *              cuando la feature `reports.metabase` está prendida en el
 *              tenant (el platform-admin la prende desde el tablero de
 *              Plataforma). El sidebar usa `v-has-feature="'reports.metabase'"`
 *              para esconder el item cuando está apagada.
 */

const reportsRoutes = [
  {
    path: "/reports",
    name: "reports-list",
    component: () =>
      import(
        /* webpackChunkName: "reports" */ "../components/reports/ReportsList.vue"
      ),
  },
  {
    path: "/reports/:key",
    name: "report-view",
    component: () =>
      import(
        /* webpackChunkName: "reports" */ "../components/reports/ReportView.vue"
      ),
  },
];

export default reportsRoutes;
